module.exports = __webpack_public_path__ + "img/logo_en.76c33c79.png";